import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const AuthProvider = useAuth();
  
  if (!AuthProvider) {
    console.error('useAuth is returning undefined');
    return <div>Error: Auth context is undefined</div>;
  }

  if (AuthProvider.isAuthLoading) {
    return null;
  }

  if (!AuthProvider.isAuthenticated) {
    return <Navigate to="/sign-in" />;
  } 

  if (allowedRoles && (!AuthProvider.userDetails || !allowedRoles.includes(AuthProvider.userDetails.role))) {
    return <Navigate to="/dashboard" />;
  }

  return children;
};

export default ProtectedRoute;
